import { OldOrderbookRes, UseOrderbookRes } from './useOrderbook.types';
import wsUtils from 'utils/webSocket';

const { parseSocketString } = wsUtils;

export const natsOrderbookFormatter = (
  rawOrderbook: OrderBookResponse,
): UseOrderbookRes => ({
  stockCode: rawOrderbook.stockCode,
  bid: parseSocketString(rawOrderbook.body).O['BID-RG'],
  offer: parseSocketString(rawOrderbook.body).O['OFFER-RG'],
});

export const oldOrderbookFormatter = (
  rawOldOrderbook: OldOrderbookRes,
): UseOrderbookRes => ({
  stockCode: rawOldOrderbook.sym,
  bid: rawOldOrderbook['BID-RG'],
  offer: rawOldOrderbook['OFFER-RG'],
});

/**
 * Defined Type Guards.
 * @link https://www.typescriptlang.org/docs/handbook/2/narrowing.html#using-type-predicates
 */
export const isNatsOrderbookResponse = (
  rawOrderbook: OrderBookResponse | OldOrderbookRes,
): rawOrderbook is OrderBookResponse =>
  (rawOrderbook as OrderBookResponse).datetime !== undefined;

// Raw Nats
// {
//   "stockCode": "GOTO",
//   "body": "#O|GOTO|BID|118;0;223613500|117;0;99554900|116;0;77776600|115;0;141316000|114;0;53095000|113;0;116110800|1678949070",
//   "sequenceNumber": "3418843",
//   "orderBookId": "4311",
//   "datetime": "2023-03-16T13:44:30.7964+07:00"
// }

// Raw Old
// {
//     "sym": "AALI",
//     "BID-RG": {
//         "price1": 7875,
//         "que_num1": 0,
//         "volume1": 2600,
//         "price2": 7850,
//         "que_num2": 0,
//         "volume2": 101800,
//         "price3": 7825,
//         "que_num3": 0,
//         "volume3": 57200,
//         "price4": 7800,
//         "que_num4": 0,
//         "volume4": 236800,
//         "price5": 7775,
//         "que_num5": 0,
//         "volume5": 12700,
//         "price6": 7750,
//         "que_num6": 0,
//         "volume6": 20900,
//         "price7": 7725,
//         "que_num7": 0,
//         "volume7": 10100,
//         "price8": 7700,
//         "que_num8": 0,
//         "volume8": 50700,
//         "price9": 7675,
//         "que_num9": 0,
//         "volume9": 21900,
//         "price10": 7650,
//         "que_num10": 0,
//         "volume10": 148900
//     },
//     "OFFER-RG": {
//       "price1": 8325,
//       "que_num1": 0,
//       "volume1": 2198200,
//       "price2": 8350,
//       "que_num2": 0,
//       "volume2": 949900,
//       "price3": 8375,
//       "que_num3": 0,
//       "volume3": 848400,
//       "price4": 8400,
//       "que_num4": 0,
//       "volume4": 1026900,
//       "price5": 8425,
//       "que_num5": 0,
//       "volume5": 864500,
//       "price6": 8450,
//       "que_num6": 0,
//       "volume6": 840200,
//       "price7": 8475,
//       "que_num7": 0,
//       "volume7": 1601900,
//       "price8": 8500,
//       "que_num8": 0,
//       "volume8": 1519500,
//       "price9": 8525,
//       "que_num9": 0,
//       "volume9": 310400,
//       "price10": 8550,
//       "que_num10": 0,
//       "volume10": 1057200
//     }
// }
